































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";

import RentalBookingJson from "../../shared/RentalBookingJson";
import CustomerJson from "../../shared/CustomerJson";
import { RentalBookingStatus, RentalBookingStatusNames } from "../../shared/RentalBookingStatus";
import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType } from "../../shared/PaymentExportType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import RentalBookingDetails from "./RentalBookingDetails.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "RentalPayments",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    RentalBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      RentalBookingStatus: RentalBookingStatus,
      RentalBookingStatusNames: RentalBookingStatusNames,
      GeneralInfos: GeneralInfos,
      showDetails: false,
      detailsMode: "read",
      paymentExports: null as RentalBookingJson[] | null,
      exportedPayments: null as PaymentExportInfoJson[] | null,
      selectedBookingId: null as number | null,
      isExporting: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    openDetails(item: RentalBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedBookingId = item.ID;
      } else {
        this.selectedBookingId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadPaymentsToExport();
      this.loadExportedPayments();
    },

    async loadPaymentsToExport() {
      this.paymentExports = null;
      if (this.restClient != null) {
        try {
          this.paymentExports = await this.restClient.getRentalBookingsReadyForPaymentExport();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadExportedPayments() {
      this.exportedPayments = null;
      if (this.restClient != null) {
        try {
          this.exportedPayments = await this.restClient.getRecentPaymentExports(PaymentExportType.rentalBookings);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //export payment data
    async exportPaymentData() {
      this.isExporting = true;

      try {
        var exportInfo = await this.restClient.exportPaymentsForRentalBookings();
        if (exportInfo != null) {
          this.downloadPaymentData(exportInfo);
        } else {
          this.isExporting = false;
          alert("Aktuell sind keine Zahlungsdaten zum Export bereit.");
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    async downloadPaymentData(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert("download: " + e.message);
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
